import { render } from "./ResetButton.vue?vue&type=template&id=48112052&scoped=true"
import script from "./ResetButton.vue?vue&type=script&lang=js"
export * from "./ResetButton.vue?vue&type=script&lang=js"

import "./ResetButton.vue?vue&type=style&index=0&id=48112052&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48112052"]])

export default __exports__